export const roundNumber = (number: string | number): number => {
  const strWithReplacedCommas = typeof number === 'string'
    ? number.replace(/,/g, '.')
    : number
  const rounded = Math.round(Number(strWithReplacedCommas) * 2) / 2
  return rounded
}
